import { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoEma from "../../assets/images/EMA_azul_chico.png";
import { HashLink } from "react-router-hash-link";
import LanguageSwitcher from "../languageSwitcher";
import { useTranslation } from "react-i18next";

export const Header = ({ color }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [drawerOpen, setDrawerOpen] = useState(false);

  const menuItems = [
    { name: t("header_titulo1"), route: "/quienes-somos/" },
    { name: t("header_titulo2"), route: "/productos/" },
    { name: t("header_titulo3"), route: "/servicios/" },
    { name: t("header_titulo4"), route: "/sitio#contacto" },
  ];

  const isActive = (route) => location.pathname + location.hash === route;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        position: "relative",
        top: 0,
        left: 0,
        zIndex: 100,
      }}
    >
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: color,
          width: "100%",
          padding: "0 20px",
          height: "4.5rem",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          boxShadow: "none",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            overflowX: "hidden",
            padding: 0,
          }}
        >
          {/* Logo */}
          <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer", marginTop: ".7rem" }}>
            <HashLink smooth to="/sitio/" style={{ textDecoration: "none" }}>
              <img
                src={LogoEma}
                alt="Logo EMA"
                style={{ width: "147px", height: "43px" }}
              />
            </HashLink>
          </Box>

          {/* Menú desktop o hamburguesa móvil */}
          {isMobile ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={() => setDrawerOpen(true)}
                sx={{ padding: "4px", color: "#1b2466", marginTop: ".5rem", marginRight: ".5rem" }}
              >
                <MenuIcon />
              </IconButton>

              <LanguageSwitcher />
              {/* Drawer */}
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
              >
                <Box sx={{ width: 250 }} role="presentation">
                  <List>
                    {menuItems.map((item) => (
                      <ListItem
                        key={item.name}
                        onClick={() => setDrawerOpen(false)}
                      >
                        <HashLink
                          smooth
                          to={item.route}
                          style={{ textDecoration: "none" }}
                        >
                          <ListItemText
                            primary={item.name}
                            primaryTypographyProps={{
                              fontFamily: "Montserrat",
                              fontWeight: 800,
                              fontSize: "18px",
                              color: "#1b2466",
                            }}
                          />
                        </HashLink>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Drawer>
            </Box>
          ) : (
            // Desktop
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "clamp(2rem, 4vw, 8rem)",
                marginLeft: "auto",
                marginRight: "2rem",
              }}
            >
              {menuItems.map((item) => (
                <HashLink
                  key={item.name}
                  smooth
                  to={item.route}
                  style={{ textDecoration: "none" }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: "Montserrat",
                      fontWeight: 600,
                      color: "#1b2466",
                      fontSize: "21px",
                      letterSpacing: "-0.1px",
                      lineHeight: "26px",
                      whiteSpace: "nowrap",
                      cursor: "pointer",
                      position: "relative",
                      "&::after": {
                        content: '""',
                        display: "block",
                        width: "100%",
                        height: "2px",
                        backgroundColor: "#1b2466",
                        position: "absolute",
                        bottom: "-5px",
                        left: 0,
                        transform: isActive(item.route)
                          ? "scaleX(1)"
                          : "scaleX(0)",
                        transformOrigin: "center",
                        transition: "transform 0.3s ease-in-out",
                      },
                      "&:hover::after": {
                        transform: "scaleX(1)",
                      },
                    }}
                  >
                    {item.name}
                  </Typography>
                </HashLink>
              ))}

              <LanguageSwitcher />
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};
